export default {
  /** 水印相机签名 */
  watermarkSignature: '/api/v1/camera/signature',
  /** 专家催场信息查询 */
  expertUrgeInfo: '/api/web/v3/staff/site/urgeDetail',
  /** 专家催场通知发送 */
  expertUrgeSend: '/api/web/v3/staff/site/urgeSend',
  /** 会场信息登录 */
  venueInfoLogin: '/api/web/v3/staff/login',
  /** 前端-获取会场端配置 */
  venueInfoConfig: '/api/web/v3/staff/config',
  /** 会场考勤列表 */
  venueAttendanceList: '/api/web/v3/staff/sites',
  /** 会场考勤详情 */
  venueAttendanceDetail: '/api/web/v3/staff/site/signInDetail',
  /** 会场考勤签到 */
  venueAttendanceSignIn: '/api/web/v3/staff/site/signInSubmit',
  /** 会场 session 详情统计 */
  venueSessionDetail: '/api/web/v3/staff/site/meetingDetail',
  /** 开幕式邀请函详情 */
  openingCeremonyInvitationDetail: '/api/web/v2/doctorhomepage/invitationstatus',
  /** 开幕式邀请函反馈 */
  openingCeremonyInvitationAction: '/api/web/v2/doctorhomepage/invitationsubmit'
}
